import { RequestService } from '../../../../../common/services/RequestService';
import { API_AUTHORIZATION_SENDCODE } from '../../constants';

export const sendCodeRequest = payload => {
  return RequestService.get(API_AUTHORIZATION_SENDCODE + '/' + payload.phone);
};
